import { render, staticRenderFns } from "./TestRouting.vue?vue&type=template&id=7d8d23f8&"
import script from "./TestRouting.js?vue&type=script&lang=js&"
export * from "./TestRouting.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports